import { motion } from "framer-motion";
import { SunLogo } from "../components/SunLogo";
import { IMG } from "../data/images";
import { useLang } from "../i18n";

const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  const { t } = useLang();

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative flex min-h-[100svh] items-center justify-center overflow-hidden bg-[#2B1E16]"
    >
      <motion.img
        src={IMG.hero}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover opacity-30"
        initial={{ scale: 1.14 }}
        animate={{ scale: 1 }}
        transition={{ duration: 14, ease: "linear" }}
      />
      <div className="absolute inset-0 bg-[#2B1E16]/70" />
      <div className="grain absolute inset-0" />

      <div className="v1-hero-content relative z-10 flex w-full max-w-[1400px] flex-col items-center px-6 py-28 text-center md:px-12">
        <SunLogo className="v1-hero-logo h-24 w-auto md:h-32" delay={0.35} />

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.9, ease: [0.22, 1, 0.36, 1] }}
          className="brand-lockup mt-7"
          dir="ltr"
        >
          <p className="brand-latin font-sans text-[10px] uppercase tracking-[0.55em] text-[#D9B98A] md:text-xs">Deseos</p>
          <p className="brand-latin mt-2 font-sans text-[9px] uppercase tracking-[0.42em] text-[#F5EDE3]/50 md:text-[10px]">
            Brunch Coffee
          </p>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 34 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 2.25, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 max-w-[16ch] font-serif text-4xl font-light leading-[1.02] tracking-tight text-[#F5EDE3] sm:text-5xl lg:text-7xl"
        >
          {t.hero.title}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 2.7 }}
          className="v1-hero-tagline mt-8 font-sans text-[10px] uppercase tracking-[0.34em] text-[#F5EDE3]/65 md:text-xs"
        >
          {t.hero.tagline}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 2.95, ease: [0.22, 1, 0.36, 1] }}
          className="v1-hero-actions mt-12 flex flex-col items-center gap-4 sm:flex-row"
        >
          <button data-testid="hero-cta-carta" onClick={() => go("carta")} className="btn-gold">
            {t.hero.ctaMenu}
          </button>
          <button data-testid="hero-cta-mapa" onClick={() => go("reserva")} className="btn-ghost">
            {t.hero.ctaBook}
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 3.4, duration: 1 }}
        className="v1-scroll-cue absolute bottom-8 left-1/2 z-10 -translate-x-1/2"
      >
        <div className="h-12 w-[1px] overflow-hidden bg-[#D9B98A]/25">
          <motion.div
            className="h-full w-full bg-[#D9B98A]"
            animate={{ y: ["-100%", "100%"] }}
            transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>
      </motion.div>
    </section>
  );
};
